<template>
  <div
    v-if="typeof source === 'string'"
    class="image-wrapper"
  >
    <img
      :src="source"
      alt=""
    >
  </div>
  <div
    v-else
    ref="slider"
    class="swiper images-slider-wrapper"
  >
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, index) in source"
        :key="index"
      >
        <div class="slider-gallery-container-img">
          <img
            :src="item.url"
            alt=""
          >
        </div>
        <a
          class="img-title"
          :href="item.url"
          rel="noopener"
          target="_blank"
          download
        >
          <span class="download-symbol">
            <svg class="icon icon-download-image"><use xlink:href="#icon-download-image"></use></svg>
          </span>
          {{ item.title }}
        </a>
      </div>
    </div>
    <div class="medias-modal-slider-navigation">
      <div
        ref="sliderBtnPrev"
        class="btn-prev"
      >
        <svg class="icon icon-medias-slider-arrow"><use xlink:href="#icon-medias-slider-arrow"></use></svg>
      </div>
      <div
        ref="sliderBtnNext"
        class="btn-next"
      >
        <svg class="icon icon-medias-slider-arrow"><use xlink:href="#icon-medias-slider-arrow"></use></svg>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

export default {
  props: {
    source: {
      type: [Array, String],
      required: true,
    },
  },
  data() {
    return {
      slider: null,
      sliderOptions: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.btn-next',
          prevEl: '.btn-prev',
        },
      },
    }
  },
  mounted() {
    this.createSlider();
    window.addEventListener('resize', this.slider.updateSize());
  },
  methods: {
    createSlider() {
      if (Array.isArray(this.source) && this.source.length > 1) {
        this.slider = new Swiper(this.$refs.slider, this.sliderOptions);
      }
    },
  },
}
</script>
